<template>
    <v-form-tile>
        <h2 slot="title">{{selectLabel}}</h2>
        <div slot="content" class="tile">
            <div class="tile-content">
                <div class="grid-content" v-if="!value">
                    <div class="grid-item grid-item-full">
                        <r-input label="Search by name" auto-focus v-model="search"/>
                    </div>
                    <div
                        class="grid-item grid-item-third"
                        v-for="(gatewayItemName) in gatewayNamesSearchResult"
                        :key="gatewayItemName">
                        <div class="gateway-item">
                            <div
                                class="avatar avatar-description"
                                @click="selectGateway(gatewayItemName)"
                                style="cursor:pointer">
                                <div class="avatar-image" v-fs-block>
                                    <figure class="image image-avatar">
                                        <img :src="gatewayImageMap[gatewayItemName]"/>
                                    </figure>
                                </div>
                                <div class="avatar-info" v-fs-block>
                                    <p><strong>{{gatewayItemName}}</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="grid-content">
                    <div class="grid-item grid-item-full">
                        <div class="avatar avatar-description avatar-l" :class="{'stack-m': !isUpdating}">
                            <div class="avatar-image" v-fs-block>
                                <figure class="image image-avatar">
                                    <img :src="gatewayImageMap[value]"/>
                                </figure>
                            </div>
                            <div class="avatar-info" v-fs-block>
                                <p><strong>{{value}}</strong></p>
                            </div>
                        </div>
                        <v-icon-button v-if="!isUpdating" @click="cancelGatewaySelection">
                            <v-icon icon="arrow-left"/>
                            Browse Gateway Accounts
                        </v-icon-button>
                    </div>
                </div>
            </div>
        </div>
    </v-form-tile>
</template>

<script>
    import resolveEntity from '@/common/spec/resolve-entity';
    import {
        vIconButton, vIcon, vFormTile,
    } from '@/components/form';
    import GatewaysImageMap from '@/data/gateways-image-map';
    import filterArrayByQuery from '@/common/helpers/filter-array-by-query';
    import {disabledGateways} from '@/modules/gateway-accounts/special-config';

    export default {
        name: 'gateway-selection',
        components: {
            vIconButton, vIcon, vFormTile,
        },
        props: {
            value: {
                type: String,
                default: null,
            },
            isUpdating: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            gatewayNames() {
                const excluded = [...disabledGateways];
                if (!this.$isSandboxMode()) {
                    excluded.push('RebillyProcessor');
                }
                const {gatewayName} = resolveEntity('GatewayAccount');
                return gatewayName.enum
                    // TODO temporary fix for no icons
                    .filter(name => !excluded.includes(name));
            },
            gatewayNamesSearchResult() {
                if (this.results && this.results.length) {
                    return this.results;
                }
                return this.gatewayNames;
            },
            selectLabel() {
                if (this.value) {
                    return `${this.value} Gateway`;
                }
                return 'Select Gateway';
            },
        },
        data() {
            return {
                search: '',
                gatewayImageMap: {...GatewaysImageMap},
            };
        },
        subscriptions() {
            const results = this.$watchAsObservable('search')
                .pluck('newValue')
                .debounceTime(300)
                .distinctUntilChanged()
                .map(this.findGatewayByName)
                .defaultIfEmpty(this.gatewayNames);
            return {
                results,
            };
        },
        methods: {
            findGatewayByName(term) {
                return filterArrayByQuery({
                    term,
                    array: this.gatewayNames,
                    value: name => name,
                });
            },
            selectGateway(gatewayName) {
                this.search = '';
                this.$emit('input', gatewayName);
            },
            cancelGatewaySelection() {
                this.$emit('selection-change');
                this.$emit('input', null);
            },
        },
    };
</script>
